// 组件注册表
// 每个组件可以独立使用，也可以在自由组件页面中组合使用

import QcPage from '../Qc.vue'
import QcaiPage from '../Qcai.vue'
import HjPage from '../Hj.vue'
import Hj2Page from '../Hj2.vue'
import QsyPage from '../Qsy.vue'
import RecordPage from '../Record.vue'
import UserInfoWidget from './UserInfoWidget.vue'
import VipWidget from './VipWidget.vue'
import StatsWidget from './StatsWidget.vue'

// 可用组件列表
export const widgetList = [
  {
    id: 'qc',
    name: '视频去重',
    icon: 'content_cut',
    component: QcPage,
    description: '智能识别重复帧，提升视频原创度',
    category: '功能',
    width: '50',
    props: { limit: 1 }
  },
  {
    id: 'qcai',
    name: '视频去重 V2',
    icon: 'auto_fix_high',
    component: QcaiPage,
    description: '选择二创特效制作去重视频',
    category: '功能',
    width: '50',
    props: { limit: 1 }
  },
  {
    id: 'hj',
    name: '视频混剪',
    icon: 'movie_edit',
    component: HjPage,
    description: '组合多个素材智能生成混剪视频',
    category: '功能',
    width: '50',
    props: { limit: 1 }
  },
  {
    id: 'hj2',
    name: '视频混剪 V2',
    icon: 'video_settings',
    component: Hj2Page,
    description: '支持高级时长控制的视频混剪',
    category: '功能',
    width: '50',
    props: { limit: 1 }
  },
  {
    id: 'qsy',
    name: '提取视频',
    icon: 'download',
    component: QsyPage,
    description: '提取文案、无水印视频和图片',
    category: '功能',
    width: '50',
    props: { limit: 1 }
  },
  {
    id: 'record',
    name: '制作记录',
    icon: 'history',
    component: RecordPage,
    description: '查看历史制作记录',
    category: '数据',
    width: '50',
    props: { limit: 3 }
  },
  {
    id: 'userinfo',
    name: '用户信息',
    icon: 'person',
    component: UserInfoWidget,
    description: '显示当前用户基本信息',
    category: '数据',
    width: '25'
  },
  {
    id: 'vip',
    name: '会员状态',
    icon: 'card_membership',
    component: VipWidget,
    description: '显示会员状态和剩余次数',
    category: '数据',
    width: '25'
  },
  {
    id: 'stats',
    name: '数据统计',
    icon: 'analytics',
    component: StatsWidget,
    description: '显示使用统计数据',
    category: '数据',
    width: '50'
  }
]

// 按分类获取组件
export function getWidgetsByCategory() {
  const categories = {}
  widgetList.forEach(widget => {
    if (!categories[widget.category]) {
      categories[widget.category] = []
    }
    categories[widget.category].push(widget)
  })
  return categories
}

// 根据ID获取组件
export function getWidgetById(id) {
  return widgetList.find(w => w.id === id)
}



// WEBPACK FOOTER //
// ./src/components/User2/widgets/index.js